module.exports = __webpack_public_path__ + "static/media/fist-light.95af3511.png";